module.exports = __webpack_public_path__ + "static/media/main idea.881fd76e.mp3";